<style scoped lang="scss" type="text/scss">
.role-container {
    display: flex;
    align-items: flex-start;
    margin-top: 1rem;

    .right-panel {
        width: 23rem;
    }

    .left-panel {
        flex: 1;
        margin-right: 1rem;

        .submit-buttons {
            margin-top: 1rem;
        }
    }

    .drag-wrap {
        .drag-container {
            min-height: 3rem;
            display: flex;
            flex-wrap: wrap;
            margin: -.5rem -.5rem 0 0;

            .ticket-item {
                margin: .5rem .5rem 0 0;

                &:hover {
                    cursor: move;
                }
            }
        }
    }

    .info-panel {
        margin-bottom: 1rem;

        &:not(:first-of-type) {
            margin-top: 1rem;
        }
    }
}
.uploader {
    width: 30%;
    float: left;
    margin: 1%;
}

.image-display {
    background-color: white;
    width: 30%;
    float: left;
    margin: 1%;
    height: 12rem;
    position: relative;
    text-align: center;
    align-items: center;}
</style>

<template>
    <div class="role-wrap">
        <middleable-managed-player-selector></middleable-managed-player-selector>
<!--        <registrable-manged-player-selector></registrable-manged-player-selector>-->
        <div class="role-container">
            <div class="left-panel">
                <block-divider>图片</block-divider>
<!--                <i-multi-image-uploader-->
<!--                    class="uploader"-->
<!--                    ref="groupPhotoImageUploader"-->
<!--                    v-model="uploadImage_photo01"-->
<!--                    :limit-types="['.png', '.jpg', '.svg', '.jpeg']"-->
<!--                    :limit-size="2 * 1024 * 1024"-->
<!--                    :src="src_photo01"-->
<!--                    :circular="false"-->
<!--                    title="合照"-->
<!--                    reversed-->
<!--                    @file-uploaded="fileUploaded_photo01"-->
<!--                >-->
<!--                    <div class="extra-info">-->
<!--                        <info-panel class="info-panel" size="small">-->
<!--                            图片类型：JPG / SVG / PNG / JPEG-->
<!--                        </info-panel>-->
<!--                        <info-panel class="info-panel" size="small">-->
<!--                            大小限制：2 MB 以下-->
<!--                        </info-panel>-->
<!--                        <info-panel class="info-panel" size="small">-->
<!--                            尺寸建议：1366 像素 * 768 像素-->
<!--                        </info-panel>-->
<!--                    </div>-->
<!--                </i-multi-image-uploader>-->
                <el-image v-if="!isDuringMiddleCheck" fit="contain" class="image-display" :src="src_photo01" :preview-src-list="[src_photo01, src_photo01]"/>
                <i-single-image-uploader
                    v-if="isDuringMiddleCheck"
                    class="uploader"
                    ref="groupPhotoImageUploader"
                    v-model="uploadImage_photo01"
                    :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                    :limit-size="10 * 1024 * 1024"
                    :src="src_photo01"
                    title="照片"
                    reversed
                    @file-uploaded="fileUploaded_photo01"
                >
                    <div class="extra-info">
                        <info-panel class="info-panel" size="small">
                            图片类型：JPG / SVG / PNG / JPEG
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            大小限制：10 MB 以下
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            尺寸建议：1920 像素 * 1080 像素
                        </info-panel>
                    </div>
                </i-single-image-uploader>

                <el-image v-if="!isDuringMiddleCheck" fit="contain" class="image-display" :src="src_photo02" :preview-src-list="[src_photo02, src_photo02]"/>
                <i-single-image-uploader
                    v-if="isDuringMiddleCheck"
                    class="uploader"
                    ref="groupPhotoImageUploader"
                    v-model="uploadImage_photo02"
                    :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                    :limit-size="10 * 1024 * 1024"
                    :src="src_photo02"
                    title="照片"
                    reversed
                    @file-uploaded="fileUploaded_photo02"
                >
                    <div class="extra-info">
                        <info-panel class="info-panel" size="small">
                            图片类型：JPG / SVG / PNG / JPEG
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            大小限制：10 MB 以下
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            尺寸建议：1920 像素 * 1080 像素
                        </info-panel>
                    </div>
                </i-single-image-uploader>

                <el-image v-if="!isDuringMiddleCheck" fit="contain" class="image-display" :src="src_photo03" :preview-src-list="[src_photo03, src_photo03]"/>
                <i-single-image-uploader
                    v-if="isDuringMiddleCheck"
                    class="uploader"
                    ref="groupPhotoImageUploader"
                    v-model="uploadImage_photo03"
                    :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                    :limit-size="10 * 1024 * 1024"
                    :src="src_photo03"
                    title="照片"
                    reversed
                    @file-uploaded="fileUploaded_photo03"
                >
                    <div class="extra-info">
                        <info-panel class="info-panel" size="small">
                            图片类型：JPG / SVG / PNG / JPEG
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            大小限制：10 MB 以下
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            尺寸建议：1920 像素 * 1080 像素
                        </info-panel>
                    </div>
                </i-single-image-uploader>

                <el-image v-if="!isDuringMiddleCheck" fit="contain" class="image-display" :src="src_photo04" :preview-src-list="[src_photo04, src_photo04]"/>
                <i-single-image-uploader
                    v-if="isDuringMiddleCheck"
                    class="uploader"
                    ref="groupPhotoImageUploader"
                    v-model="uploadImage_photo04"
                    :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                    :limit-size="10 * 1024 * 1024"
                    :src="src_photo04"
                    title="照片"
                    reversed
                    @file-uploaded="fileUploaded_photo04"
                >
                    <div class="extra-info">
                        <info-panel class="info-panel" size="small">
                            图片类型：JPG / SVG / PNG / JPEG
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            大小限制：10 MB 以下
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            尺寸建议：1920 像素 * 1080 像素
                        </info-panel>
                    </div>
                </i-single-image-uploader>

                <el-image v-if="!isDuringMiddleCheck" fit="contain" class="image-display" :src="src_photo05" :preview-src-list="[src_photo05, src_photo05]"></el-image>
                <i-single-image-uploader
                    v-if="isDuringMiddleCheck"
                    class="uploader"
                    ref="groupPhotoImageUploader"
                    v-model="uploadImage_photo05"
                    :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                    :limit-size="10 * 1024 * 1024"
                    :src="src_photo05"
                    title="照片"
                    reversed
                    @file-uploaded="fileUploaded_photo05"
                >
                    <div class="extra-info">
                        <info-panel class="info-panel" size="small">
                            图片类型：JPG / SVG / PNG / JPEG
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            大小限制：10 MB 以下
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            尺寸建议：1920 像素 * 1080 像素
                        </info-panel>
                    </div>
                </i-single-image-uploader>

                <el-image v-if="!isDuringMiddleCheck" fit="contain" class="image-display" :src="src_photo06" :preview-src-list="[src_photo06, src_photo06]"></el-image>
                <i-single-image-uploader
                    v-if="isDuringMiddleCheck"
                    class="uploader"
                    ref="groupPhotoImageUploader"
                    v-model="uploadImage_photo06"
                    :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                    :limit-size="10 * 1024 * 1024"
                    :src="src_photo06"
                    title="照片"
                    reversed
                    @file-uploaded="fileUploaded_photo06"
                >
                    <div class="extra-info">
                        <info-panel class="info-panel" size="small">
                            图片类型：JPG / SVG / PNG / JPEG
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            大小限制：10 MB 以下
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            尺寸建议：1920 像素 * 1080 像素
                        </info-panel>
                    </div>
                </i-single-image-uploader>

                <el-image v-if="!isDuringMiddleCheck" fit="contain" class="image-display" :src="src_photo07" :preview-src-list="[src_photo07, src_photo07]"></el-image>
                <i-single-image-uploader
                    v-if="isDuringMiddleCheck"
                    class="uploader"
                    ref="groupPhotoImageUploader"
                    v-model="uploadImage_photo07"
                    :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                    :limit-size="10 * 1024 * 1024"
                    :src="src_photo07"
                    title="照片"
                    reversed
                    @file-uploaded="fileUploaded_photo07"
                >
                    <div class="extra-info">
                        <info-panel class="info-panel" size="small">
                            图片类型：JPG / SVG / PNG / JPEG
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            大小限制：10 MB 以下
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            尺寸建议：1920 像素 * 1080 像素
                        </info-panel>
                    </div>
                </i-single-image-uploader>



                <block-divider>视频</block-divider>
                <div class="image-display" v-if="!isDuringMiddleCheck" >
                    {{src_video01 ? src_video01.name: '暂无视频'}}
                </div>
                <i-single-documentation-uploader
                    v-if="isDuringMiddleCheck"
                    class="uploader"
                    v-model="uploadImage_video01"
                    :limit-types="['.mp4']"
                    :limit-size="200 * 1024 * 1024"
                    title="视频"
                    reversed
                    :file-info="src_video01"
                    @file-uploaded="fileUploaded_video01"
                >
                    <div class="extra-info">
                        <info-panel class="info-panel" size="small">
                            文件类型：MP4
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            大小限制：200 MB 以下
                        </info-panel>
                    </div>
                </i-single-documentation-uploader>



                <block-divider>其他资料(可选)</block-divider>

                <div class="image-display" v-if="!isDuringMiddleCheck" >
                  {{src_doc01 ? src_doc01.name: '暂无文档'}}
                </div>
                <i-single-documentation-uploader
                    v-if="isDuringMiddleCheck"
                    class="uploader"
                    v-model="uploadImage_doc01"
                    :limit-types="['.pdf', '.doc', '.docx']"
                    :limit-size="10 * 1024 * 1024"
                    title="其他文档"
                    reversed
                    :file-info="src_doc01"
                    @file-uploaded="fileUploaded_doc01"
                >
                  <div class="extra-info">
                    <info-panel class="info-panel" size="small">
                      文件类型：PDF, DOC, DOCX
                    </info-panel>
                    <info-panel class="info-panel" size="small">
                      大小限制：10 MB 以下
                    </info-panel>
                  </div>
                </i-single-documentation-uploader>

                <div class="image-display" v-if="!isDuringMiddleCheck" >
                    {{src_video02 ? src_video02.name: '暂无视频'}}
                </div>
                <i-single-documentation-uploader
                    v-if="isDuringMiddleCheck"
                    class="uploader"
                    v-model="uploadImage_video02"
                    :limit-types="['.mp4']"
                    :limit-size="500 * 1024 * 1024"
                    title="其他视频"
                    reversed
                    :file-info="src_video02"
                    @file-uploaded="fileUploaded_video02"
                >
                    <div class="extra-info">
                        <info-panel class="info-panel" size="small">
                            文件类型：MP4
                        </info-panel>
                        <info-panel class="info-panel" size="small">
                            大小限制：500 MB 以下
                        </info-panel>
                    </div>
                </i-single-documentation-uploader>

              <div class="image-display" v-if="!isDuringMiddleCheck" >
                {{src_doc02 ? src_doc02.name: '暂无文档'}}
              </div>
              <i-single-documentation-uploader
                  v-if="isDuringMiddleCheck"
                  class="uploader"
                  v-model="uploadImage_doc02"
                  :limit-types="['.zip','.x_zip', '.rar','.y_rar','.x_rar', '.7z']"
                  :limit-size="500 * 1024 * 1024"
                  title="其他压缩包"
                  reversed
                  :file-info="src_doc02"
                  @file-uploaded="fileUploaded_doc02"
              >
                <div class="extra-info">
                  <info-panel class="info-panel" size="small">
                    文件类型：ZIP, RAR, 7Z
                  </info-panel>
                  <info-panel class="info-panel" size="small">
                    大小限制：500 MB 以下
                  </info-panel>
                </div>
              </i-single-documentation-uploader>

<!--                <div class="image-display" v-if="!isDuringMiddleCheck" >-->
<!--                    {{src_video03 ? src_video03.name: '暂无视频'}}-->
<!--                </div>-->
<!--                <i-single-documentation-uploader-->
<!--                    v-if="isDuringMiddleCheck"-->
<!--                    class="uploader"-->
<!--                    v-model="uploadImage_video03"-->
<!--                    :limit-types="['.mp4']"-->
<!--                    :limit-size="200 * 1024 * 1024"-->
<!--                    title="中期检查视频"-->
<!--                    reversed-->
<!--                    :file-info="src_video03"-->
<!--                    @file-uploaded="fileUploaded_video03"-->
<!--                >-->
<!--                    <div class="extra-info">-->
<!--                        <info-panel class="info-panel" size="small">-->
<!--                            文件类型：MP4-->
<!--                        </info-panel>-->
<!--                        <info-panel class="info-panel" size="small">-->
<!--                            大小限制：200 MB 以下-->
<!--                        </info-panel>-->
<!--                    </div>-->
<!--                </i-single-documentation-uploader>-->



<!--                <block-divider>提交文档</block-divider>-->


<!--               -->

<!--                <div class="image-display" v-if="!isDuringMiddleCheck" >-->
<!--                    {{src_doc03 ? src_doc03.name: '暂无文档'}}-->
<!--                </div>-->
<!--                <i-single-documentation-uploader-->
<!--                    v-if="isDuringMiddleCheck"-->
<!--                    class="uploader"-->
<!--                    v-model="uploadImage_doc03"-->
<!--                    :limit-types="['.pdf', '.doc', '.docx']"-->
<!--                    :limit-size="10 * 1024 * 1024"-->
<!--                    title="中期检查文档"-->
<!--                    reversed-->
<!--                    :file-info="src_doc03"-->
<!--                    @file-uploaded="fileUploaded_doc03"-->
<!--                >-->
<!--                    <div class="extra-info">-->
<!--                        <info-panel class="info-panel" size="small">-->
<!--                            文件类型：PDF, DOC, DOCX-->
<!--                        </info-panel>-->
<!--                        <info-panel class="info-panel" size="small">-->
<!--                            大小限制：10 MB 以下-->
<!--                        </info-panel>-->
<!--                    </div>-->
<!--                </i-single-documentation-uploader>-->
            </div>
        </div>
        <middle-check-count-down></middle-check-count-down>

    </div>
</template>

<script>
import BlockDivider from '../../../../components/divider/block';
import SpecialCompetitionItem from '../../../sub-components/special-competition-item/index';
import Placeholder from '../../../../components/placeholder/index';
import {mapState} from 'vuex';
import InfoPanel from "../../../../components/info-panel/index.vue";
import ISingleImageUploader from "../../../../components/i-uploader/single-image-uploader.vue";
import IMultiImageUploader from "../../../../components/i-uploader/multi-image-uploader.vue";
import _ from "lodash";
import ISingleDocumentationUploader from "../../../../components/i-uploader/single-documentation-uploader.vue";
import ISingleUpload from "../../../../components/i-uploader/single.vue";
import MiddleableManagedPlayerSelector from "../../../sub-components/middleable-managed-player-selector/index.vue";
import MiddleCheckCountDown from "../../../sub-components/middle-check-count-down/index.vue";
import {calcStatusBoolean, format} from "../../../../utils/time";

export default {
    name: '',
    components: {
        MiddleCheckCountDown,
        MiddleableManagedPlayerSelector,
        ISingleUpload,
        ISingleDocumentationUploader,
        ISingleImageUploader,
        IMultiImageUploader,
        InfoPanel,
        BlockDivider,
        SpecialCompetitionItem,
        Placeholder
    },
    data() {
        return {
            uploadImage_photo01: {},
            uploadImage_photo02: {},
            uploadImage_photo03: {},
            uploadImage_photo04: {},
            uploadImage_photo05: {},
            uploadImage_photo06: {},
            uploadImage_photo07: {},
            uploadImage_doc01: {},
            uploadImage_doc02: {},
            uploadImage_doc03: {},
            uploadImage_video01: {},
            uploadImage_video02: {},
            uploadImage_video03: {},

        };
    },
    computed: {
        ...mapState('player', {
            currentMiddlePlayerId: state => state.currentMiddlePlayerId,
            currentMiddlePlayerInfo: state => state.currentMiddlePlayerInfo,
            specialCompetitions: state => state.currentMiddlePlayerSpecialCompetitions
        }),
        isDuringMiddleCheck () {
            const middleCheckDeadline = _.get(this.currentMiddlePlayerInfo, 'competition.middle_check_deadline', null);
            const middleCheckStartTime = _.get(this.currentMiddlePlayerInfo, 'competition.middle_check_start_time', null);
            if (middleCheckDeadline === null) {
                return false;
            }
            // console.log(middleCheckDeadline)
            let s = calcStatusBoolean(middleCheckStartTime, middleCheckDeadline)
            // console.log(s)
            return s;
        },
        src_photo01() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_photo01_url', null);
        },
        src_photo02() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_photo02_url', null);
        },
        src_photo03() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_photo03_url', null);
        },
        src_photo04() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_photo04_url', null);
        },
        src_photo05() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_photo05_url', null);
        },
        src_photo06() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_photo06_url', null);
        },
        src_photo07() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_photo07_url', null);
        },
        src_doc01() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_doc01_object', null);
        },
        src_doc02() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_doc02_object', null);
        },
        src_doc03() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_doc03_object', null);
        },
        src_video01() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_video01_object', null);
        },
        src_video02() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_video02_object', null);
        },
        src_video03() {
            return _.get(this.currentMiddlePlayerInfo, 'middle_check_video03_object', null);
        },
    },
    watch: {},
    methods: {
        fileUploaded_photo01(fileInfo, _, throwFail) {
            this.fileUploaded_inner("photo_01", fileInfo, throwFail)
        },
        fileUploaded_photo02(fileInfo, _, throwFail) {
            this.fileUploaded_inner("photo_02", fileInfo, throwFail)
        },
        fileUploaded_photo03(fileInfo, _, throwFail) {
            this.fileUploaded_inner("photo_03", fileInfo, throwFail)
        },
        fileUploaded_photo04(fileInfo, _, throwFail) {
            this.fileUploaded_inner("photo_04", fileInfo, throwFail)
        },
        fileUploaded_photo05(fileInfo, _, throwFail) {
            this.fileUploaded_inner("photo_05", fileInfo, throwFail)
        },
        fileUploaded_photo06(fileInfo, _, throwFail) {
            this.fileUploaded_inner("photo_06", fileInfo, throwFail)
        },
        fileUploaded_photo07(fileInfo, _, throwFail) {
            this.fileUploaded_inner("photo_07", fileInfo, throwFail)
        },
        fileUploaded_doc01(fileInfo, _, throwFail) {
            this.fileUploaded_inner("doc_01", fileInfo, throwFail)
        },
        fileUploaded_doc02(fileInfo, _, throwFail) {
            this.fileUploaded_inner("doc_02", fileInfo, throwFail)
        },
        fileUploaded_doc03(fileInfo, _, throwFail) {
            this.fileUploaded_inner("doc_03", fileInfo, throwFail)
        },
        fileUploaded_video01(fileInfo, _, throwFail) {
            this.fileUploaded_inner("video_01", fileInfo, throwFail)
        },
        fileUploaded_video02(fileInfo, _, throwFail) {
            this.fileUploaded_inner("video_02", fileInfo, throwFail)
        },
        fileUploaded_video03(fileInfo, _, throwFail) {
            this.fileUploaded_inner("video_03", fileInfo, throwFail)
        },
        fileUploaded_inner(content, fileInfo, throwFail) {
            this.$normalRequest('player/updateMiddleCheck', {
                id: this.currentMiddlePlayerId,
                content: content,
                ...fileInfo
            }, '上传成功').then(_ => {
                this.$store.dispatch('player/loadRegistrableMiddlePlayerInfo').then();
                fileInfo.finish_callback();
            }).catch(_ => {
                throwFail();
                fileInfo.finish_callback();
            });
        }
    }
};
</script>
